export const getCurrentMonth = (): [number, number] => {
  const date = new Date()
  return [
    date.getMonth() + 1,
    date.getFullYear()
  ]
}